module.exports = __webpack_public_path__ + "img/business-affiliate-network.34ee6a4c.svg";